import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ApplicationContextService, Environment, ENVIRONMENT, EnvironmentService, FrameCommunicationService } from 'lib-core-shared';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  versionNumber: string = this.env.version;
  environment!: Environment;

  constructor(private router: Router, @Inject(ENVIRONMENT) private env: Environment, private envService: EnvironmentService, public context: ApplicationContextService, public frameCommsService: FrameCommunicationService, private authService: MsalService) {
    this.envService.settings = env;
    this.environment = env;
    this.envService.settings = env;
  }

  title = 'product-management';

  goto() {
    this.router.navigate(['search', {relativeTo: this.router}]);
  }

  ngOnInit(): void {
    //watch the height of the document body
    var elementResizedObserver = new ResizeObserver(entries => {

      if(entries && entries[0] && entries[0].contentRect && entries[0].contentRect.height && entries[0].contentRect.height > 200){
        this.frameCommsService.postAppHeightToParent(Math.ceil(entries[0].contentRect.height), 'product-management-resize');
      }

    })

    //react to new elements(modals) being added/removed from the body
    var elementAddedObserver = new MutationObserver( (mutations) => {

      //we only care about modals being added or removed as they will increase/decrease the height of the page
      if (document.getElementsByClassName('modal-dialog') && document.getElementsByClassName('modal-dialog')
        .length) {

        //stop watching body height while we resolve height required for modal otherwise one will trigger the other
        elementResizedObserver.unobserve(document.body);

        var modalHeight = document.getElementsByClassName('modal-dialog')[0].clientHeight + 100; // 100px is the additional height needed for modals

        //the modal may be shorter than the page it lives on, we shouldn't use the modal height in that case
        if(modalHeight > document.body.clientHeight){
          this.frameCommsService.postAppHeightToParent(modalHeight, 'product-management-resize')
        }else{
          this.frameCommsService.postAppHeightToParent(document.body.clientHeight, 'product-management-resize');
        }

      //no modals on the page, continue watching body height
      } else {
        elementResizedObserver.observe(document.body);
      }

    })

    if(this.context.isApplicationEmbedded() && this.context.isReactingToAppSizeRequired()){
      elementResizedObserver.observe(document.body)
      elementAddedObserver.observe(document, {
        attributes: false,
        childList: true,
        characterData: false,
        subtree: true
      });
    }
  }

  logout() { 
    this.authService.logoutPopup({
      mainWindowRedirectUri: "/"
    });
}
}
